import authService from '@/services/authService'
import httpClientService from '@/services/httpClientService'

export default class ReferralService {
  static getReferrals () {
    return httpClientService
      .getAPIHttpClient()
      .get(`/health-care-practitioner/${authService.getHCPID()}/referrals`)
  }
}
